import { FunctionComponent, ReactElement, useContext, useRef } from 'react';
import styled from 'styled-components';
import { apiClient } from '../../adapters/api-client';
import { GenderInputDS, HolderSalaryRules, NumericInput, NumericInputDS } from '../../components/DesignSystem';
import { useFetch } from '../../hooks/useFetch';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import { FormTips } from '../../styles/TypoStyle';
import { ValidityHtmlElement } from '../../utils/DsType';

const Container = styled.div`
  selected-button {
    max-width: 30%;
    min-width: 23px;
  }
`;
const InfoText = styled.div`
  border-radius: 4px;
  background-color: rgb(229, 245, 253);
  color: #4a4a4a;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 16px;
  padding: 16px;
  margin-top: 16px;
  font-family: 'Open Sans';
`;
const Suffixe = styled(FormTips)``;

const Revenus: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const {
    state: { budget },
    apiStatus,
    dispatch,
  } = useContext(store);
  const months = [12, 13, 14, 15];
  const holderSalaryRef = useRef<NumericInputDS>(null);
  const monthlyPaymentCountRef = useRef<GenderInputDS>(null);
  const situationRef = useRef<GenderInputDS>(null);
  const { response: contracts } = useFetch(() => apiClient().referential.getContracts());
  const onMonthChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    if (!!monthlyPaymentCountRef && monthlyPaymentCountRef.current !== null) {
      (monthlyPaymentCountRef.current as unknown as ValidityHtmlElement).assignValidity();
      dispatch(updateStore({ budget: { income: { monthlyPaymentCount: e.currentTarget?.value } } }));
    }
  };
  const onHolderSalaryChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(
      updateStore({
        budget: { income: { holderSalaryAmount: Number(String(e.currentTarget?.value).replace(/\s/g, '')) } },
      }),
    );
  };
  return (
    <>
      <Container>
        <NumericInput
          class="to-validate trackable-blur"
          label="Revenus de votre foyer"
          required
          with-reset
          maxLength="5"
          placeholder="Montant"
          onLetterChanged={onHolderSalaryChange}
          onInputChange={onHolderSalaryChange}
          value={budget?.income?.holderSalaryAmount}
          replacement={HolderSalaryRules.replacement}
          customValidityPattern={HolderSalaryRules.customValidityPattern}
        />
        {/* <Suffixe>Salaire + prime(s), retraite(s), pré-retraite(s), revenu(s) d'activité libérale, etc.</Suffixe> */}
        {/* <GenderInput
          ref={monthlyPaymentCountRef}
          label="Nombre de mois de salaire par an"
          class="to-validate trackable-click"
          data-id="monthlyPaymentCount"
          onSelectedElementChange={onMonthChange}
          value={income?.monthlyPaymentCount || ''}
          error-message="Veuillez nous indiquer sur combien de mois vous percevez votre salaire."
        >
          {months &&
            months.map((value) => (
              <SelectedButton key={value} value={value}>
                {value}
              </SelectedButton>
            ))}
        </GenderInput> */}
        <></>
        <InfoText>
          <span
            rv-text="model.app.rcsi.RCSI.RCSI_infosPerso_LIB060"
            rv-aria-label="model.app.rcsi.RCSI.RCSI_infosPerso_LIB060"
            aria-label="Renseignez vos revenus, ainsi que celui de votre conjoint, avant prélèvement à la source."
          >
            Renseignez vos revenus, ainsi que celui de votre conjoint, avant prélèvement à la source.
          </span>
          <br />
          <br />
          <span
            rv-html="model.app.rcsi.RCSI.RCSI_infosPerso_LIB061"
            rv-aria-label="model.app.rcsi.RCSI.RCSI_infosPerso_LIB061"
            aria-label="<strong>Exemple si vous êtes payé sur 13 mois :</strong><br>(Revenu net avant prélèvement de l'impôt x 13) ÷12<br><strong>Ex :</strong> (2266,83 x 13) ÷ 12  "
          >
            <strong>Exemple si vous êtes payé sur 13 mois :</strong>
            <br />
            (Revenu net avant prélèvement de l'impôt x 13) ÷12
            <br />
            <strong>Ex :</strong> (2266,83 x 13) ÷ 12{' '}
          </span>
        </InfoText>
      </Container>
    </>
  );
};

export default Revenus;
